<template>
  <div class="container page">
    <van-nav-bar :title="$t('setting.language')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>
    <div class="items">
      <div
        v-for="item in languageOptions"
        :key="item.code"
        class="item van-hairline--bottom"
        @click="changeLang(item.code)"
      >
        <div class="flex_center">
          <!-- <div class="flag">{{ item.short }}</div> -->
          <div class="info">
            <div class="primary">{{ item.nativeLabel }}</div>
            <div class="secondary">{{ item.englishLabel }}</div>
          </div>
        </div>
        <div v-if="lang === item.code" class="checked">&#10003;</div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "vant";

export default {
  name: "Language",
  data() {
    return {
      lang: this.$i18n.locale || "en_us",
      source: '',
      languageOptions: [
        { code: 'yn_yu', nativeLabel: 'Tiếng Việt', englishLabel: 'Vietnamese', short: 'VI' },
        { code: 'it_it', nativeLabel: 'Italiano', englishLabel: 'Italian', short: 'IT' },
        { code: 'de_de', nativeLabel: 'Deutsch', englishLabel: 'German', short: 'DE' },
        { code: 'es_spa', nativeLabel: 'Español', englishLabel: 'Spanish', short: 'ES' },
        { code: 'ko_hy', nativeLabel: '한국어', englishLabel: 'Korean', short: 'KR' },
        { code: 'ja_jp', nativeLabel: '日本語', englishLabel: 'Japanese', short: 'JP' },
        { code: 'ga_ie', nativeLabel: 'Gaeilge', englishLabel: 'Irish', short: 'IE' },
        { code: 'fr_fr', nativeLabel: 'Français', englishLabel: 'French', short: 'FR' },
        { code: 'nl_nl', nativeLabel: 'Nederlands', englishLabel: 'Dutch', short: 'NL' },
        { code: 'da_dk', nativeLabel: 'Dansk', englishLabel: 'Danish', short: 'DK' },
        { code: 'no_no', nativeLabel: 'Norsk', englishLabel: 'Norwegian', short: 'NO' },
        { code: 'idn_yu', nativeLabel: 'Bahasa Indonesia', englishLabel: 'Indonesian', short: 'ID' },
        { code: 'ms_my', nativeLabel: 'Bahasa Melayu', englishLabel: 'Malay', short: 'MY' },
        { code: 'pt_pt', nativeLabel: 'Português', englishLabel: 'Portuguese', short: 'PT' },
        { code: 'sg_en', nativeLabel: 'English (Singapore)', englishLabel: 'Singapore English', short: 'SG' },
        { code: 'cs_cz', nativeLabel: 'Čeština', englishLabel: 'Czech', short: 'CZ' },
        { code: 'th_th', nativeLabel: 'ไทย', englishLabel: 'Thai', short: 'TH' },
        { code: 'zh_cn', nativeLabel: '中文', englishLabel: 'Chinese', short: 'ZH' },
        { code: 'en_us', nativeLabel: 'English', englishLabel: 'English (US)', short: 'EN' }
      ]
    };
  },
  mounted() {
    this.source = this.$route.params.type;
  },
  methods: {
    back() {
      return window.history.back();
    },
    changeLang(lang) {
      Toast.loading({
        duration: 200,
      });
      this.lang = lang;
      this.$i18n.locale = lang;
      localStorage.setItem("lang", lang);
      if (this.source === 'setting') {
        this.$router.push({ path: '/' });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

.container .items {
  background-color: #fff;
  font-size: 30px;
  color: #000;
  padding: 0 25px;
}

.container .items .item {
  padding: 18px 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom-width: 10px;
}

.container .items .van-hairline--bottom::after {
  border-bottom-width: 3px;
}

.flex_center {
  display: flex;
  align-items: center;
  min-width: 0;
}

.flag {
  width: 60px;
  height: 60px;
  margin-right: 20px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4c206f, #323795);
  color: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  flex-shrink: 0;
}

.info {
  min-width: 0;
}

.primary {
  font-size: 30px;
  color: #1f1f1f;
  line-height: 1.2;
}

.secondary {
  margin-top: 6px;
  font-size: 22px;
  color: #8b8b95;
  line-height: 1.1;
}

.checked {
  color: #4c206f;
  font-size: 34px;
  font-weight: 700;
}
</style>
